import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet-async";

function RegisterPendingVerification() {
  const [loading, setLoading] = useState(false);

  const email = sessionStorage.getItem("pending_verification_email");

  const handleResendEmail = async () => {
    if (!email) {
      toast.error("Aucune adresse email trouvée. Veuillez vous réinscrire.");
      return;
    }

    try {
      setLoading(true);

      const response = await api.post("/resend-verification-email", {
        email,
      });

      toast.success(response.data?.message || "Email renvoyé avec succès.");
    } catch (error) {
      console.error(error);

      toast.error(
        error.response?.data?.message || "Erreur lors du renvoi de l'email."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet>
      <title>Vérification en attente | LMFP Photography</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div className="flex min-h-screen items-center justify-center bg-black px-4 text-white">
      <div className="w-full max-w-2xl rounded-3xl border border-white/10 bg-white/5 p-8 text-center shadow-2xl backdrop-blur-md md:p-12">
        <div className="mb-6 flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full border border-blue-400/30 bg-blue-500/20">
            <svg
              className="h-10 w-10 text-blue-400"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>

        <p className="mb-3 text-sm uppercase tracking-[0.25em] text-gray-400">
          LMFP Photography
        </p>

        <h1 className="mb-4 text-3xl font-bold md:text-4xl">
          Vérifiez votre adresse email
        </h1>

        <p className="mb-4 text-base leading-relaxed text-gray-300 md:text-lg">
          Votre compte a bien été créé. Un email de confirmation vient de vous
          être envoyé.
        </p>

        {email && (
          <p className="mb-4 text-sm text-orange-400 md:text-base">{email}</p>
        )}

        <p className="mb-8 text-sm text-gray-400 md:text-base">
          Cliquez sur le lien reçu par email pour activer votre compte. Pensez
          aussi à vérifier vos spams.
        </p>

        <div className="flex flex-col justify-center gap-4 sm:flex-row">
          <button
            onClick={handleResendEmail}
            disabled={loading}
            className="rounded-xl bg-orange-500 px-6 py-3 font-semibold text-white transition hover:bg-orange-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {loading ? "Envoi..." : "Renvoyer l’email"}
          </button>

          <Link
            to="/login"
            className="rounded-xl border border-white/20 px-6 py-3 text-white transition hover:bg-white/10"
          >
            Aller à la connexion
          </Link>
        </div>
      </div>

      <ToastContainer />
    </div>
    </>
  );
}

export default RegisterPendingVerification;